// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"646cd5fcf21111a958f4","223":"955b3945f1f671d0fbbe","224":"3bd68c3be5411215a70a","275":"8adc5cde2ce7675d7240"}[chunkId] + ".chunk.js";
};